import { DELIVERY_STATES } from '../../../lib/deliveryStates';

// The delivery states an empty retrieval may transition from — «Recuperación vacía» records that
// the mensajero opened the «buzón» to retrieve the parcel and found it empty. Matched
// case-insensitively (the wire is lowercase; older fixtures are TitleCase). Fail closed: an
// unrecognized state is not non-retrievable. Exact legacy parity: pedidos.php offers
// empty_retrieval to the courier from en_taquilla/devolucion_central/rejected and from nowhere
// else — in particular `retrieved` is NOT eligible (product decision: a mistaken «Recuperado»
// stays terminal here, as in the legacy; the reverse correction lives in isRetrievable, which
// includes non_retrieved). Eligibility is by STATE alone — no Devolución gate, like its siblings.
// Spellings come from the canonical constants (backend-confirmed underscores).
const NON_RETRIEVABLE_STATES = new Set<string>([
  DELIVERY_STATES.stored,
  DELIVERY_STATES.expired,
  DELIVERY_STATES.rejected,
]);

export function isNonRetrievable(status: string): boolean {
  return NON_RETRIEVABLE_STATES.has(status.toLowerCase());
}
